// extracted by mini-css-extract-plugin
export default {"root":"styles_root__fv3Bt","noteContent":"styles_noteContent__ymwMh"};